module.exports = __webpack_public_path__ + "static/media/e-commerce_active.55777056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/e-commerce_active.svg
// module id = 1083
// module chunks = 36